import { API_URL_V3 } from 'constants/index';
import { fetch } from 'services/apiV3/fetch';

const recurringReceivables = {
  fetch: ({ perPage = 5, page = 1 } = {}) => {
    const url = `${API_URL_V3}/recurring_receivables?per_page=${perPage}&page=${
      page < 1 ? 1 : page
    }`;
    const options = { method: 'GET' };

    return fetch(url, options);
  },

  cancel: id => {
    const url = `${API_URL_V3}/recurring_receivables/${id}/cancellation`;
    const options = { method: 'POST', body: {} };

    return fetch(url, options);
  },
};

export { recurringReceivables };
